import { render, staticRenderFns } from "./AllCategories.vue?vue&type=template&id=72ed9de2&scoped=true"
import script from "./AllCategories.vue?vue&type=script&lang=js"
export * from "./AllCategories.vue?vue&type=script&lang=js"
import style0 from "./AllCategories.vue?vue&type=style&index=0&id=72ed9de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed9de2",
  null
  
)

export default component.exports